import { useContext } from "react";
import { workspaceAdminContext } from "../context/WorkspaceAdminContext";

export const useWorkspaceAdminContext = () => {
  const context = useContext(workspaceAdminContext);

  if (context === undefined) {
    throw new Error(
      "Hook useWorkspaceAdminContext is used outside of its Provider."
    );
  }

  return context;
};
